import * as React from "react";
import { Modal,Button,Input,Radio,message} from "antd";
import { connect } from "react-redux";
const { TextArea } = Input;
interface IMssageProps {
  id:any;
  getQNConfig:any;
  email:any;
  goTime:any;
  skuName:any;
  contact:any;
  sendMail:any;
  phone:any;
  taoAccount:any;
  sendSMS:any;
  sendWechatTemplate: any;
  autoMail:any;
}

// 确认函
class Mssage extends React.Component<IMssageProps, any> {
  state = {
    visible:false,
    name:'',
    type:'message',
    email:'',
    emailnew:'',
    title:'',
    phone:'',
    messageContent:'亲，你的订单已经支付成功，请尽快联系客服完善订单信息。',
    wechatContent:'',
    emailContent:'',
  };
  constructor(props: IMssageProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (prevState.email != nextProps.email) {
      this.setState({
        email:this.props.email,
        emailnew:this.props.email,
        phone:this.props.phone,
        title:this.props.contact+this.props.goTime+this.props.skuName,
      });
      return false;
    }
    return true;
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  onChange =(value) => {
    this.setState({
       text:value.target.value
    })     
  }
  
  onSelect = event =>{
      this.setState({
        type:event.target.value
       })   
  }


  change = (name,value) =>{
    if(name == 'email'){
      this.setState({
        emailnew:value.target.value
       })       
    }else if(name == 'messageContent'){
      this.setState({
         messageContent:value.target.value
      })
    }else if(name == 'phone'){
      this.setState({
         phone:value.target.value
      })
    }else if(name == 'wechatContent'){
      this.setState({
        wechatContent:value.target.value
      })
    }else if(name == 'emailContent'){
      this.setState({
        emailContent:value.target.value
      })
    }else{
      this.setState({
        title:value.target.value
       })       
    }
  } 
  send = () =>{
    if(this.state.type == 'message'){
        const param: any = {
          id: this.props.id,
          phone:this.state.phone,
          content:this.state.messageContent,
        }; 
        this.props.sendSMS({
          ...param,
          callback: (data) => {
             this.handleCancel();      
          }
        });
    }
    if(this.state.type == 'wechat'){
      const param: any = {
        id: this.props.id,
        text:this.state.wechatContent,
      }; 
      this.props.sendWechatTemplate({
        ...param,
        callback: (data) => {
           this.handleCancel();      
        }
      });
    }   
    if(this.state.type == 'email'){
      const param: any = {
        email: this.state.email,
        title: this.state.title,
        content:this.state.emailContent,
      }; 
      this.props.autoMail({
        ...param,
        callback: (data) => {
          if(data.length == 0){
            this.handleCancel();
          }else{
            console.log(data);
            for (let value of data.res.data) {
              console.log(value);
              message.error(value);
            }
          }        
        }
      });
    }
  }

  getEmail(){
     if(this.state.type == 'email'){
       return(
          <React.Fragment>
                <div className="hang"><label className="f">收件邮箱：</label><span><Input onChange={this.change.bind(this,'email')} value={this.state.emailnew} className="messge" /></span></div>
                <div className="hang"><label className="f">邮件标题：</label><span><Input  value={this.state.title} onChange={this.change.bind(this,'title')}  className="messge"  /></span></div>
                <div className="hang"><label className="f">内容：</label><span><TextArea value={this.state.emailContent} onChange={this.change.bind(this,'emailContent')}  rows={3} /></span></div>           
          </React.Fragment>
       )
     }else{
       return false
     }
  }

  getMessage(){
    if(this.state.type == 'message'){
      return(
         <React.Fragment>
               <div className="hang"><label className="f">姓名：</label><span>{this.props.contact}</span></div>
               <div className="hang"><label className="f">国内手机号：</label><span><Input  value={this.state.phone} onChange={this.change.bind(this,'phone')}  className="messge"  /></span></div>
               <div className="hang"><label className="f">内容：</label><span><TextArea value={this.state.messageContent} onChange={this.change.bind(this,'messageContent')}  rows={3} /></span></div>           
         </React.Fragment>
      )
    }else{
      return false
    }
 }

 getWechat(){
  if(this.state.type == 'wechat'){
    return(
       <React.Fragment>
             <div className="hang"><label className="f">联系人姓名：</label><span>{this.props.contact}</span></div>
             <div className="hang"><label className="f">淘宝账号：</label><span>{this.props.taoAccount}</span></div>
             <div className="hang"><label className="f">微信内容：</label><span><TextArea value={this.state.wechatContent} onChange={this.change.bind(this,'wechatContent')}  rows={3} /></span></div>           
       </React.Fragment>
    )
  }else{
    return false
  }
}

  render() {
    return (
      <React.Fragment>
      <Button onClick={this.show.bind(this,this.props.id)}>发送消息</Button> 
      <Modal maskClosable={false} onCancel={this.handleCancel} title="发送消息"  visible={this.state.visible} footer={null} width="auto" centered={true}>
          <div className="wechat-push">
                <div className="hang hradio"><label className="f">类型：</label><span>     
                <Radio.Group defaultValue="message" buttonStyle="solid" onChange={this.onSelect}>
                  <Radio.Button value="message">短信</Radio.Button>
                  <Radio.Button value="wechat">微信</Radio.Button>
                  <Radio.Button value="email">邮件</Radio.Button>
                </Radio.Group>
                </span></div> 
                {this.getMessage()}
                {this.getEmail()}
                {this.getWechat()}
          </div>
          <div className="down-confirmation">
          <Button type="primary" onClick={this.send} >发送</Button>
           </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
  skuName: state.orderDetails.skuName,
  phone: state.orderDetails.phone,
  goTime:state.orderDetails.goTime,
  email:state.orderDetails.email,
  contact:state.orderDetails.contact,
  taoAccount:state.orderDetails.taoAccount,
});

const mapDispatch = dispatch => {
  return {
    getQNConfig: dispatch.orderDetails.getQNConfig,
    sendMail:dispatch.orderDetails.sendMail,
    sendSMS:dispatch.orderDetails.sendSMS,
    autoMail:dispatch.orderDetails.autoMail,
    sendWechatTemplate: dispatch.orderDetails.sendWechatTemplate,
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Mssage);
